module.exports = __webpack_public_path__ + "img/logo.38e9f7f2.svg";